import React from 'react';
import type { ControlProps } from '@atlaskit/select';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import { xcss, Box } from '@atlaskit/primitives';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import type { SelectOption } from '../../../../common/types.tsx';
import { StyledControl } from '../../../../common/ui/picker/styled.tsx';

export const Control = ({ children, innerProps, innerRef }: ControlProps<SelectOption, true>) => (
	<StyledControl ref={innerRef ?? undefined} {...innerProps}>
		{isVisualRefreshEnabled() && (
			<Box xcss={wrapperStyles}>
				<SearchIcon LEGACY_size="small" label="" />
			</Box>
		)}
		{children}
	</StyledControl>
);

const wrapperStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	paddingLeft: 'space.100',
});

export default Control;
